<p>optional-complete-activity-view works!</p>
